<template>
  <div class="facts-about bg--color-02">
    <div class="container-wrapper facts-about__container">
      <div class="facts-about__content container-new">
        <h5
          class="facts-about__title txt--32px txt--40px--m txt--height-40px txt--height-52px--m txt--color-04 txt--bold mb-0"
        >
          {{ $t('latinAmerica.factsAboutCountries.title') }}
        </h5>
        <img
          class="facts-about__image"
          src="@/assets/img/latin-america/facts/country-image.svg"
          width="100%"
          alt="country image"
        >
        <div class="facts-about__list">
          <div v-for="item in list" :key="list[item]" class="facts-about__item">
            <div class="facts-about__item-icon">
              <!-- <img :src="item.icon" width="100%" alt="country flag"> -->
              <img
                :src="item.flag"
                width="30"
                height="30"
                loading="lazy"
                :alt="item.key"
              >
            </div>
            <p
              class="txt--weight-400 txt--16px txt--22px--l txt--height-20px txt--height-30px--l txt--color-04 mb-0"
              v-html="item.text"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FactsAbout',
  computed: {
    list () {
      return ['br', 'mx', 'ch', 'sv', 've', 'cu', 'pa'].map((flag, index) => ({
        key: flag,
        flag: require(`@/assets/icons/countries/${flag}.png`),
        text: this.$t(`latinAmerica.factsAboutCountries.list.${index}`),
      }))

      // return [
      //   {
      //     icon: require('@/assets/img/latin-america/facts/countries/brazil.png'),
      //     text: this.$t('latinAmerica.factsAboutCountries.list[0]'),
      //   },
      //   {
      //     icon: require('@/assets/img/latin-america/facts/countries/venezuela.svg'),
      //     text: this.$t('latinAmerica.factsAboutCountries.list[1]'),
      //   },
      //   {
      //     icon: require('@/assets/img/latin-america/facts/countries/venezuela.svg'),
      //     text: this.$t('latinAmerica.factsAboutCountries.list[2]'),
      //   },
      //   {
      //     icon: require('@/assets/img/latin-america/facts/countries/el-salvador.svg'),
      //     text: this.$t('latinAmerica.factsAboutCountries.list[3]'),
      //   },
      //   {
      //     icon: require('@/assets/img/latin-america/facts/countries/cuba.svg'),
      //     text: this.$t('latinAmerica.factsAboutCountries.list[4]'),
      //   },
      //   {
      //     icon: require('@/assets/img/latin-america/facts/countries/panama.svg'),
      //     text: this.$t('latinAmerica.factsAboutCountries.list[5]'),
      //   },
      // ]
    },
  },
}
</script>

<style lang="scss" scoped>
.facts-about {
  &__container {
    background: #a5d4ff;
  }

  &__content {
    display: grid;
    grid-template-areas: 'title' 'image' 'list';
    gap: toRem(18px);

    @include bp(m) {
      grid-template-areas: 'image title' 'image list';
      grid-template-rows: min-content 1fr;
      grid-template-columns: 1fr 1.4fr;
    }

    @include bp(l) {
      gap: toRem(24px);
    }
  }

  &__title {
    grid-area: title;
  }

  &__image {
    grid-area: image;
    max-width: toRem(510px);
    margin: 0 auto;

    @include bp(m) {
      margin: auto auto auto 0;
      max-width: 100%;
    }
  }

  &__list {
    grid-area: list;
    display: flex;
    flex-direction: column;
    gap: toRem(24px);
  }

  &__item {
    display: flex;
    align-items: center;
    gap: toRem(20px);
  }

  &__item-icon {
    border-radius: toRem(12px);
    min-width: toRem(44px);
    min-height: toRem(44px);
    background: color('color-01');
    display: flex;
    align-items: center;
    justify-content: center;

    // img {
    //   max-width: toRem(29px);
    //   max-height: toRem(24px);
    // }
  }
}
</style>
